export default __webpack_public_path__ + "static/media/074-notification-1.f6c8d01b.svg";